module.exports = {
	"classes": [
		"gdpr-page",
		"header-dark"
	],
	"title": "Let GDPR jump-start identity innovation with Auth0",
	"metas": {
		"description": "Adding required GDPR capabilities and features gives you the opportunity to innovate identity access for the apps you build. Auth0’s IAM solution offers flexible tools to craft the features needed to meet your business and GDPR compliance requirements including breached password, and brute force protection."
	},
	"opengraph": {
		"og:title": "Let GDPR jump-start identity innovation with Auth0",
		"og:description": "Adding required GDPR capabilities and features gives you the opportunity to innovate identity access for the apps you build. Auth0’s IAM solution offers flexible tools to craft the features needed to meet your business and GDPR compliance requirements including breached password, and brute force protection.",
		"og:url": "https://auth0.com/gdpr/",
		"og:image": "http://cdn.auth0.com/website/gdpr/gdpr_twitter_card.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/gdpr/gdpr_twitter_card.png"
	},
	"twittercard": {
		"twitter:title": "Let GDPR jump-start identity innovation with Auth0",
		"twitter:description": "Adding required GDPR capabilities and features gives you the opportunity to innovate identity access for the apps you build. Auth0’s IAM solution offers flexible tools to craft the features needed to meet your business and GDPR compliance requirements including breached password, and brute force protection.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/gdpr/gdpr_twitter_card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/gdpr/metadata.json
// module id = 1388
// module chunks = 0